import { SaveAltOutlined } from '@mui/icons-material';
import { IconButton, TableCell, TableRow, Typography, Chip } from '@mui/material';
import type { OrganizationSubscriptionInvoiceItemDto } from '@/types/dtos/transactions/subscription-invoice.dto';
import { roundToTwoDecimals } from '@/helpers/decimal.helper';
import { format } from 'date-fns';
import { useDownloadSubscriptionInvoiceMutation } from '@/state/mutations/transactions/use-download-subscription-invoice-mutation';
import { useTranslations } from '@/i18n/use-translations';

export default function SubscriptionInvoiceRow({
  organizationId,
  item,
}: {
  organizationId: string;
  item: OrganizationSubscriptionInvoiceItemDto;
}) {
  const t = useTranslations();
  const { mutateAsync: download, isPending } = useDownloadSubscriptionInvoiceMutation();

  const canDownload = !!item.invoiceId && !item.invoiceSupportPending;

  const handleDownload = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!canDownload) return;
    await download({ organizationId, transactionId: item.id });
  };

  const amount =
    item.chargedAmountEur !== undefined && item.chargedAmountEur !== null
      ? `€${roundToTwoDecimals(item.chargedAmountEur).toFixed(2)}`
      : '—';

  return (
    <TableRow>
      <TableCell>{format(new Date(item.createdAt), 'dd/MM/yyyy')}</TableCell>
      <TableCell>{t('organization.invoice.typeSubscription')}</TableCell>
      <TableCell align="right">{amount}</TableCell>
      <TableCell align="right">
        {item.invoiceSupportPending ? (
          <Chip
            size="small"
            label={t('organization.invoice.statusPendingSupport')}
            color="warning"
            variant="outlined"
          />
        ) : item.invoiceId ? (
          <Typography color="text.primary">{t('organization.invoice.statusIssued')}</Typography>
        ) : (
          <Typography color="text.secondary">—</Typography>
        )}
      </TableCell>
      <TableCell align="left">
        <IconButton
          size="small"
          onClick={handleDownload}
          disabled={!canDownload || isPending}
          aria-label={t('organization.invoice.download')}
        >
          <SaveAltOutlined />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
